export function formatNumber(value) {
  const num = parseFloat(value);
  if (isNaN(num)) return "0.00";
  return new Intl.NumberFormat("en-US", {
    style:'currency',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
}
